export default __webpack_public_path__ + "static/media/newHackdfwLogo2023 (1).97b890f6.png";